<p-dialog
  [(visible)]="open"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [baseZIndex]="10000"
  [style]="{ width: '60vw', minHeight: '80vh' }"
>
  <ng-template pTemplate="header">
    <h2>{{ activity.title }}</h2>
    <span>{{ activity.description }}</span>
  </ng-template>

  <ng-template pTemplate="content">
    @if (isLoadingDetail) {
      <p-skeleton height="20rem" />
    } @else if (isUploading) {
      <div class="flex flex-col items-center justify-center gap-4 h-80 bg-gray-100 rounded-lg">
        <i class="pi pi-spin pi-spinner text-3xl"></i>
      </div>
    } @else if (!imagePreviewUrl) {
      <label class="upload-btn p-button-rounded p-button-outlined cursor-pointer">
        <div class="flex flex-col items-center justify-center gap-4 w-full h-80 bg-gray-100 rounded-lg p-4">
          <span>{{ 'pre-employment.file-upload-dialog.upload.description' | translate }}</span>
          <i class="pi pi-upload"></i>
          <input type="file" accept=".jpg,.jpeg,.png,.pdf" (change)="onFileUpload($event)" hidden />
        </div>
      </label>
    } @else {
      <div class="flex items-center flex-col justify-between gap-4 h-full min-w-0 w-full bg-gray-100 rounded-lg p-4">
        <div class="flex items-center justify-center min-w-0 w-full">
          @if (fileName?.endsWith('.pdf')) {
            <div class="min-h-60 flex items-center gap-4 min-w-0">
              <i class="pi pi-file-pdf text-3xl shrink-0"></i>
              <a
                (click)="onOpenPdf()"
                class="text-blue-600 hover:text-blue-800 truncate min-w-0 cursor-pointer"
                rel="noopener noreferrer"
              >
                {{ fileName }}
              </a>
            </div>
          } @else {
            <div class="flex flex-col items-center gap-1">
              <img class="object-contain rounded h-fit min-h-60 max-w-full" [src]="imagePreviewUrl" [alt]="fileName" />
              <p>{{ fileName }}</p>
            </div>
          }
        </div>

        <button
          pButton
          type="button"
          class="p-button-rounded p-button-text p-button-danger shrink-0"
          (click)="onRemoveFile()"
        >
          <i class="pi pi-trash"></i>
        </button>
      </div>
    }
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton type="button" [label]="'selfservice.dialog.cancel' | translate" (click)="onClose()"></button>
    <button
      pButton
      type="button"
      [label]="'selfservice.dialog.confirm' | translate"
      (click)="save()"
      [disabled]="!hasNewFile"
    ></button>
  </ng-template>
</p-dialog>
